import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PropertyGroup } from '../../components';

import css from './ListingPage.module.css';
import { localizeFilters } from '../../util/filtersLocalizationHelpers';
import { ICONS_BY_OPTION_KEY } from '../../util/filterIcons';

const SectionAmenitiesPopMaybe = props => {
  const { options, publicData, intl } = props;
  if (!publicData) {
    return null;
  }

  const selectedOptions = publicData && publicData.amenities_pop ? publicData.amenities_pop : [];
  return (
    <div className={css.sectionDescription}>
      <h2 className={css.descriptionTitle}>
        <FormattedMessage id="ListingPage.AmenitiesPopTitle" />
      </h2>

      <PropertyGroup
        id="amenities_pop"
        options={localizeFilters(options, intl)}
        selectedOptions={selectedOptions}
        twoColumns={true}
        iconsByKey={ICONS_BY_OPTION_KEY}
      />
    </div>
  );
};

export default SectionAmenitiesPopMaybe;
